<div class="trailer-swap-source-details" [formGroup]="detailsForm">
  <h2>{{'step title' | translate: ['tmc.transport-attach-detach.dialog.step.title.trailer-swap-source-details', translationService.language]}}</h2>

  <div class="row" *ngIf="trailerNumberPlateRequired">
    <mat-form-field  class="col first">
      <input matInput name="trailerNumberPlate" formControlName="trailerNumberPlate"
        placeholder="{{'trailer number plated' | translate: ['tmc.transport-attach-detach.dialog.label.trailerNumberPlate', translationService.language]}}"
        [maxlength]="255" [required]="true">
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field  class="col first">
      <input matInput name="swapTrailerNumber" formControlName="swapTrailerNumber"
        placeholder="{{'swap trailer number' | translate: ['tmc.transport-attach-detach.dialog.label.swapTrailerNumber', translationService.language]}}"
        [maxlength]="255" [required]="swapTrailerNumberRequired">
    </mat-form-field>
  </div>
</div>